export const navatticTourIds = {
  PRODUCT_TOUR: 'yj330a39',
  AP_AUTOMATION_TOUR: 'z4s02t8',
} as const
